import React from 'react'

import StreamCardContainer from '../stream-card/StreamCardContainer'

const StreamCardRoute = () => (<StreamCardContainer />)

export default StreamCardRoute
